// extracted by mini-css-extract-plugin
export default {"range":"_range_zBRfnZ","labels":"_labels_hbuGi0","label":"_label_t+q08N"};